// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Z1mR","colCheckbox":"styles_colCheckbox__2gz_B"};